(() => {
  const roots = [
    ...document.querySelectorAll(
      '[data-elite-reference-card-grid], [data-elite-collection-grid][data-collection-handle="gaming-pcs"], [data-elite-collection-grid][data-collection-handle="shop-by-processor"]'
    ),
  ];

  if (!roots.length) return;

  const thumbnailsForGallery = (gallery) => (
    [...gallery.querySelectorAll('[data-reference-gallery-thumbnail]')]
  );

  const activeThumbnailIndex = (gallery, thumbnails) => {
    const activeIndex = thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active'));
    return activeIndex >= 0 ? activeIndex : 0;
  };

  const revealThumbnail = (gallery, thumbnail) => {
    const viewport = gallery.querySelector('.elite-reference-card__thumb-viewport');
    const track = gallery.querySelector('[data-reference-gallery-track]');

    if (!viewport || !track || !thumbnail) return;

    const viewportRect = viewport.getBoundingClientRect();
    const thumbnailRect = thumbnail.getBoundingClientRect();
    const itemLeft = track.scrollLeft + (thumbnailRect.left - viewportRect.left);
    const itemRight = itemLeft + thumbnailRect.width;
    const visibleLeft = track.scrollLeft;
    const visibleRight = visibleLeft + viewport.clientWidth;

    if (itemLeft < visibleLeft) {
      track.scrollTo({ left: itemLeft, behavior: 'smooth' });
    } else if (itemRight > visibleRight) {
      track.scrollTo({ left: itemRight - viewport.clientWidth, behavior: 'smooth' });
    }
  };

  const selectThumbnail = (gallery, nextIndex) => {
    const thumbnails = thumbnailsForGallery(gallery);
    const image = gallery.querySelector('.elite-reference-card__hero-image');

    if (!thumbnails.length || !image) return;

    const boundedIndex = ((nextIndex % thumbnails.length) + thumbnails.length) % thumbnails.length;
    const thumbnail = thumbnails[boundedIndex];
    const nextSource = thumbnail.dataset.imageSrc;
    const nextSourceSet = thumbnail.dataset.imageSrcset;
    const nextAlt = thumbnail.dataset.imageAlt;

    if (nextSource) image.src = nextSource;
    if (nextSourceSet) image.srcset = nextSourceSet;
    if (nextAlt) image.alt = nextAlt;

    thumbnails.forEach((item, index) => {
      const selected = index === boundedIndex;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    const status = gallery.querySelector('[data-reference-gallery-status]');
    if (status) status.textContent = `Image ${boundedIndex + 1} of ${thumbnails.length}`;

    revealThumbnail(gallery, thumbnail);
  };

  roots.forEach((root) => {
    if (root.dataset.eliteReferenceCardGalleryBound === 'true') return;

    root.dataset.eliteReferenceCardGalleryBound = 'true';

    if (root.closest('.elite-featured-products--reference')) {
      root.querySelectorAll('img[loading="eager"]').forEach((image) => {
        image.decode?.().catch(() => {});
      });
    }

    root.addEventListener('click', (event) => {
      const thumbnail = event.target.closest('[data-reference-gallery-thumbnail]');
      const previous = event.target.closest('[data-reference-gallery-previous]');
      const next = event.target.closest('[data-reference-gallery-next]');
      const control = thumbnail || previous || next;

      if (!control || !root.contains(control)) return;

      const gallery = control.closest('[data-reference-card-gallery]');
      if (!gallery) return;

      const thumbnails = thumbnailsForGallery(gallery);
      if (!thumbnails.length) return;

      if (thumbnail) {
        selectThumbnail(gallery, Number(thumbnail.dataset.imageIndex) || 0);
        return;
      }

      const currentIndex = activeThumbnailIndex(gallery, thumbnails);
      selectThumbnail(gallery, currentIndex + (previous ? -1 : 1));
    });
  });
})();
